import { pickBestComposition } from './pickBestComposition';
import { flattenLayout } from './flattenLayout';
import { getTemplateAPIVersion } from '../version';
import { CustomTemplateDataSchema } from '../../model/templates/schemas';
import { TemplateCustom } from '../../../client/templates/templates';

export function validateTemplateData(
  notification: TemplateCustom,
  validateIndicator?: boolean
): void {
  const options = notification.templateOptions;
  const body = options.body;
  const bestComposition = pickBestComposition(body.compositions);
  if (!bestComposition && !body.fallbackText) {
    throw new Error(
      `Could not find a suitable composition with the version supported by the service.\
      Notification Center instance might be too old to show this template. (Template API Version: ${getTemplateAPIVersion()})`
    );
  }
  body.compositions = [];
  if (bestComposition) {
    CustomTemplateDataSchema.validateSync(notification.templateData, {
      context: {
        fragments: flattenLayout(bestComposition.layout),
      },
    });
    body.compositions.push(bestComposition);
  }

  // this one's a bit of a scope creep.
  // notification indictor color has precedence over template indicator color
  if (validateIndicator && notification.indicator && options.indicator?.color) {
    notification.indicator.color = options.indicator.color;
  }
}
